import React from 'react';
import { FaGasPump, FaCheckCircle, FaExclamationTriangle, FaSpinner, FaWallet } from 'react-icons/fa';

const TransactionConfirmModal = ({
    isOpen,
    onClose,
    title = "Confirmar Transacción",
    status, // 'calculating', 'ready', 'error'
    gasEstimate, // string e.g. "0.00045 BNB"
    errorMessage,
    onConfirm,
    actionLabel = "Continuar a Wallet"
}) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            background: 'rgba(0,0,0,0.75)', backdropFilter: 'blur(4px)',
            zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px'
        }}>
            <div style={{
                background: '#1a1b23', border: '1px solid #444', borderRadius: '16px',
                width: '100%', maxWidth: '400px', boxShadow: '0 25px 50px rgba(0,0,0,0.5)',
                overflow: 'hidden'
            }}>

                {/* Header */}
                <div style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '16px', borderBottom: '1px solid #444'
                }}>
                    <h3 style={{ margin: 0, color: '#fff', fontWeight: 'bold', fontSize: '1.1rem' }}>{title}</h3>
                    <button
                        onClick={onClose}
                        disabled={status === 'calculating'}
                        style={{
                            background: 'none', border: 'none', color: '#999', fontSize: '1.4rem',
                            cursor: status === 'calculating' ? 'not-allowed' : 'pointer', lineHeight: 1
                        }}
                    >
                        &times;
                    </button>
                </div>

                {/* Content */}
                <div style={{
                    padding: '24px', display: 'flex', flexDirection: 'column',
                    alignItems: 'center', textAlign: 'center', gap: '12px'
                }}>

                    {/* Calculating */}
                    {status === 'calculating' && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <div style={{
                                width: '64px', height: '64px', borderRadius: '50%',
                                background: 'rgba(59,130,246,0.1)', display: 'flex',
                                alignItems: 'center', justifyContent: 'center', marginBottom: '16px'
                            }}>
                                <FaSpinner style={{ color: '#60a5fa', fontSize: '1.8rem', animation: 'spin 1s linear infinite' }} />
                            </div>
                            <h4 style={{ margin: 0, color: '#fff', fontWeight: 600, fontSize: '1.1rem' }}>Calculando comisión de red...</h4>
                            <p style={{ margin: '8px 0 0', color: '#999', fontSize: '0.75rem' }}>Validando transacción con la blockchain.</p>
                        </div>
                    )}

                    {/* Ready */}
                    {status === 'ready' && (
                        <>
                            <div style={{
                                width: '64px', height: '64px', borderRadius: '50%',
                                background: 'rgba(74,222,128,0.1)', display: 'flex',
                                alignItems: 'center', justifyContent: 'center', marginBottom: '8px'
                            }}>
                                <FaGasPump style={{ color: '#4ade80', fontSize: '1.8rem' }} />
                            </div>
                            <h4 style={{ margin: 0, color: '#fff', fontWeight: 600, fontSize: '1.1rem' }}>Transacción Lista</h4>
                            <div style={{
                                width: '100%', background: '#13141b', borderRadius: '12px',
                                padding: '12px', border: '1px solid #444', marginTop: '8px'
                            }}>
                                <p style={{ margin: '0 0 6px', color: '#999', fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Costo Estimado de Red</p>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    <span style={{ color: '#fff', fontFamily: 'monospace', fontSize: '1.25rem' }}>{gasEstimate}</span>
                                    <span style={{
                                        fontSize: '0.7rem', background: '#444', color: '#ccc',
                                        padding: '2px 8px', borderRadius: '4px'
                                    }}>Gas</span>
                                </div>
                            </div>
                            <p style={{ margin: '8px 0 0', color: '#999', fontSize: '0.85rem' }}>
                                Haz clic en continuar para abrir tu wallet y firmar la operación.
                            </p>
                        </>
                    )}

                    {/* Error */}
                    {status === 'error' && (
                        <>
                            <div style={{
                                width: '64px', height: '64px', borderRadius: '50%',
                                background: 'rgba(239,68,68,0.1)', display: 'flex',
                                alignItems: 'center', justifyContent: 'center', marginBottom: '8px'
                            }}>
                                <FaExclamationTriangle style={{ color: '#f87171', fontSize: '1.8rem' }} />
                            </div>
                            <h4 style={{ margin: 0, color: '#fff', fontWeight: 600, fontSize: '1.1rem' }}>Error de Estimación</h4>
                            <p style={{
                                margin: 0, color: '#fca5a5', fontSize: '0.85rem',
                                background: 'rgba(127,29,29,0.2)', padding: '12px',
                                borderRadius: '8px', width: '100%', textAlign: 'left'
                            }}>
                                {errorMessage || "No se pudo estimar el gas. La red puede estar congestionada o tienes fondos insuficientes para la comisión."}
                            </p>
                        </>
                    )}

                </div>

                {/* Footer Actions */}
                <div style={{
                    padding: '16px', borderTop: '1px solid #444', background: '#13141b',
                    borderRadius: '0 0 16px 16px', display: 'flex', gap: '12px', justifyContent: 'center'
                }}>
                    {status === 'ready' ? (
                        <button
                            onClick={onConfirm}
                            style={{
                                width: '100%', padding: '12px 16px',
                                background: 'linear-gradient(to right, #2563eb, #4f46e5)',
                                color: '#fff', fontWeight: 'bold', border: 'none',
                                borderRadius: '12px', cursor: 'pointer', fontSize: '1rem',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                boxShadow: '0 4px 15px rgba(37,99,235,0.3)'
                            }}
                        >
                            <FaWallet /> {actionLabel}
                        </button>
                    ) : (
                        <button
                            onClick={onClose}
                            disabled={status === 'calculating'}
                            style={{
                                width: '100%', padding: '12px 16px',
                                background: status === 'calculating' ? '#374151' : '#4b5563',
                                color: status === 'calculating' ? '#9ca3af' : '#fff',
                                fontWeight: 'bold', border: 'none', borderRadius: '12px',
                                cursor: status === 'calculating' ? 'not-allowed' : 'pointer',
                                fontSize: '1rem'
                            }}
                        >
                            {status === 'error' ? 'Cerrar' : status === 'calculating' ? 'Calculando...' : 'Cancelar'}
                        </button>
                    )}
                </div>
            </div>

            {/* Keyframe for spinner */}
            <style>{`
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
};

export default TransactionConfirmModal;
